import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const disabledColor = 'rgba(0, 0, 0, 0.3)';

const StyledButton = styled.div`
    color: rgba(0, 0, 0, 0.87);
    z-index: 1;
    border-radius: 5px;
    display: inline-flex;
    font-size: 16px;
    height: 48px;
    padding: 0 15px;
    transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
    white-space: nowrap;

    ${ (props) => {
        if (props.disabled) {
            return `
                color: ${ disabledColor };
            `;
        }

        return `
            cursor: pointer;

            &:hover {
                background: rgba(0, 0, 0, 0.1);
            }
        `;
    } }
`;

const Button = (props) => {
    const {
        children,
        disabled,
        onClick,
        style,
    } = props;

    return (
        <StyledButton
            onClick={ disabled ? null : onClick }
            disabled={ disabled }
            style={ style }
        >
            { children }
        </StyledButton>
    );
};

Button.defaultProps = {
    disabled: false,
};

Button.propTypes = {
    children: PropTypes.node.isRequired,
    disabled: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    style: PropTypes.object,
};

export default Button;



// WEBPACK FOOTER //
// ./src/components/ui/general/Button.js